import Typography from '@alltrails/shared/denali/components/Typography';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import { NUM_USERS, NUM_CURATED_TRAILS, LOGGED_DISTANCE } from 'constants/CommunityStats';
import { MapStatsUtil } from 'utils/map_stats_util';
import { Key } from 'react';
import PlusBadge from '@alltrails/shared/denali/components/PlusBadge';
import Shroom from '@alltrails/shared/illustrations/Shroom';
import Footprints from '@alltrails/shared/illustrations/Footprints';
import * as styles from './Highlights.module.scss';

import signSrc from './sign.svg';
import onePercentSrc from './one-percent.svg';
import starReviewsSrc from './star-reviews.svg';

const FIVE_STAR_REVIEWS = 900;

const highlights = [
  {
    description: (
      <FormattedMessage defaultMessage="AllTrails is the most trusted and used outdoor platform in the world and is frequently ranked as a Top 5 Health and Fitness app." />
    ),
    heading: <FormattedMessage defaultMessage="Over {fiveStarReviews}k+ 5 star reviews" values={{ fiveStarReviews: FIVE_STAR_REVIEWS }} />,
    icon: starReviewsSrc
  },
  {
    description: (
      <FormattedMessage
        defaultMessage="We're home to the largest collection of curated trails with more than {curatedTrails}k trails worldwide, and {loggedDistance} million miles of trails."
        values={{ curatedTrails: NUM_CURATED_TRAILS, loggedDistance: MapStatsUtil.metersToMiles(LOGGED_DISTANCE, 0) }}
      />
    ),
    heading: <FormattedMessage defaultMessage="Over {curatedTrails}k+ trails worldwide" values={{ curatedTrails: NUM_CURATED_TRAILS }} />,
    icon: signSrc // different from @alltrails/shared/illustrations/Sign
  },
  {
    description: (
      <FormattedMessage defaultMessage="We help people explore the outdoors safely by keeping them on the right path with trail maps, on-trail navigation, and status updates to loved ones." />
    ),
    heading: <FormattedMessage defaultMessage="On-trail safety features" />,
    icon: <Footprints color="currentcolor" size="xs" />
  },
  {
    description: (
      <FormattedMessage defaultMessage="AllTrails is available for free, but our premium subscription to AllTrails+ is available for purchase and includes our full suite of time-saving, safety, and planning features." />
    ),
    heading: <FormattedMessage defaultMessage="Explore more with AllTrails+" />,
    icon: <PlusBadge size="xl" />
  },
  {
    description: (
      <FormattedMessage defaultMessage="Millions of people around the world trust us as their one-stop shop for trail navigation and outdoor community connection." />
    ),
    heading: <FormattedMessage defaultMessage="Community of {fellowExplorers}+ million people" values={{ fellowExplorers: NUM_USERS }} />,
    icon: <Shroom color="currentcolor" size="xs" />
  },
  {
    description: (
      <FormattedMessage defaultMessage="As proud 1% for the Planet partners, we contribute part of our annual revenue to organizations that protect and increase equitable access to the outdoors." />
    ),
    heading: <FormattedMessage defaultMessage="We put our money where the trails are" />,
    icon: onePercentSrc
  }
];

// Desktop: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=1701%3A10880&t=eYPxUX4Ha19x4ECZ-4
// Mobile: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=1701-11386&t=3iCzUOrB1ngnoqZo-4
export default function Hightlights() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Typography color="inverse" component="div" variant="heading600">
          <FormattedMessage defaultMessage="Highlights" />
        </Typography>
        <Typography className={styles.paragraph} color="inverse" component="div" variant="paragraph300">
          <FormattedMessage defaultMessage="Each day, we’re dedicated to growing our offerings to make AllTrails even better for the people we serve." />
        </Typography>
        <div className={styles.highlights}>
          {highlights.map((highlight, index) => (
            <div key={index as Key}>
              {typeof highlight.icon === 'string' ? <img alt="" src={highlight.icon} /> : highlight.icon}
              <Typography className={styles.heading} color="inverse" component="div" variant="heading400">
                {highlight.heading}
              </Typography>
              <Typography color="inverse" variant="paragraph200">
                {highlight.description}
              </Typography>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
